import type { AuthenticationResult, IPublicClientApplication } from '@azure/msal-browser';

const isE2E = import.meta.env.VITE_E2E === 'true';

export const requestAccessToken = async (
  instance: IPublicClientApplication,
  scopes: string[],
): Promise<string | null> => {
  const accounts = instance.getAllAccounts();
  const account = accounts[0];

  if (!account) {
    // Keep local/dev visibility but avoid noisy E2E output.
    if (!isE2E) {
      //todo: handle this case better
      console.warn('Unable to get the access token. No account found');
    }
    return null;
  }

  try {
    // Silently acquire an access token which is then attached to the request for the ML Graph API
    // Note: instance is already initialized in MsalContextProvider, no need to call initialize() again
    const token: AuthenticationResult = await instance.acquireTokenSilent({
      scopes: scopes,
      account: account || undefined,
    });

    return token.accessToken;
  } catch (error) {
    console.error('Error acquiring access token', error);
    return null;
  }
};
